// extracted by mini-css-extract-plugin
export default {"overlayContainer":"main__overlayContainer___c_pIO"};